import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setProgramType, setSelectedReduxNonDateBasedProgram } from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';

const ProgramContainer = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 18px;
  color: ${({ theme }) => theme.colors.text};
  padding-bottom: 10px;
  padding-left: 10px;
  background-color: ${({ isSelected, theme }) => (isSelected ? theme.colors.surfaceSecondary : 'transparent')};
`;

const ProgramIconAndName = styled('div')`
  display: flex;
  align-items: center;
`;

const ProgramNameWrapper = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
`;

const ProgramName = styled('div')`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

const CollapsibleProgram = ({
  program, isSelected, isModal, closeModal,
}) => {
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();

  const handleProgramClick = () => guardNavigation(() => {
    // Dispatch actions to set program type and select the program
    dispatch(setProgramType('free-form-program'));
    dispatch(setSelectedReduxNonDateBasedProgram(program));

    // Close modal if in modal context
    if (isModal && closeModal) {
      closeModal();
    }
  });

  return (
    <ProgramContainer data-program-id={program.id} isSelected={isSelected}>
      <ProgramIconAndName>
        <ProgramNameWrapper onClick={handleProgramClick}>
          <ProgramName>{program.programName}</ProgramName>
        </ProgramNameWrapper>
      </ProgramIconAndName>
    </ProgramContainer>
  );
};

CollapsibleProgram.propTypes = {
  program: PropTypes.instanceOf(Object).isRequired,
  isSelected: PropTypes.bool,
  isModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

CollapsibleProgram.defaultProps = {
  isSelected: false,
  isModal: false,
  closeModal: null,
};

export default CollapsibleProgram;
